import { render, staticRenderFns } from "./RetailMovil.vue?vue&type=template&id=a3f51db4"
import script from "./RetailMovil.vue?vue&type=script&lang=js"
export * from "./RetailMovil.vue?vue&type=script&lang=js"
import style0 from "./RetailMovil.vue?vue&type=style&index=0&id=a3f51db4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports